"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Accordion.css");

var _utils = require("../../utils");

var _uid = _interopRequireDefault(require("../../utils/uid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Accordion(props) {
  var children = props.children,
      accordion = props.accordion,
      defaultActiveKey = props.defaultActiveKey,
      classNameProp = props.className,
      onChange = props.onChange;
  var className = (0, _utils.getClassNames)('Accordion', classNameProp);

  var _useState = (0, _react.useState)(defaultActiveKey),
      _useState2 = _slicedToArray(_useState, 2),
      activeKeys = _useState2[0],
      setActiveKeys = _useState2[1];

  var changeActiveKeys = function changeActiveKeys(keys) {
    setActiveKeys(keys);
    if (typeof onChange === 'function') onChange(keys);
  };

  var onClickItem = function onClickItem(key) {
    if (accordion) {
      changeActiveKeys(activeKeys[0] === key ? [] : [key]);
      return;
    }

    var activeKey = _toConsumableArray(activeKeys);

    var index = activeKey.indexOf(key);
    var isActive = index > -1;

    if (isActive) {
      activeKey.splice(index, 1);
    } else {
      activeKey.push(key);
    }

    changeActiveKeys(activeKey);
  };

  var getNewChild = function getNewChild(child) {
    if (!child) return null;
    var disabled = child.props.disabled;
    var key = child.key || (0, _uid.default)('panel');
    var isActive = activeKeys.indexOf(key) > -1;
    var props = {
      panelKey: key,
      isActive: isActive,
      accordion: accordion,
      onItemClick: disabled ? null : onClickItem
    };

    if (typeof child.type === 'string') {
      return child;
    }

    return /*#__PURE__*/(0, _react.cloneElement)(child, props);
  };

  var childrenWithProps = _react.default.Children.map(children, getNewChild);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, childrenWithProps);
}

Accordion.propTypes = {
  /** Whether the Collapse renders as Accordion */
  accordion: _propTypes.default.bool,

  /** Keys of the initial active panel */
  defaultActiveKey: _propTypes.default.arrayOf(_propTypes.default.string),

  /** @ignore */
  className: _propTypes.default.string,

  /** @ignore */
  children: _propTypes.default.node,

  /** Callback function executed when active panel is changed */
  onChange: _propTypes.default.func
};
Accordion.defaultProps = {
  accordion: false,
  defaultActiveKey: [],
  className: null,
  children: null,
  onChange: function onChange() {}
};
var _default = Accordion;
exports.default = _default;